/**
 * <s-local-time data-time-zone="Area/City">: shows the current time in that time zone (h:mm AM/PM),
 * refreshed on the minute. Used for the studio clock in the homepage trust section.
 */
class SLocalTime extends HTMLElement {
  #timer = 0;

  connectedCallback() {
    const zone = this.dataset.timeZone || 'UTC';
    let format;
    try {
      format = new Intl.DateTimeFormat(document.documentElement.lang || 'en', { hour: 'numeric', minute: '2-digit', timeZone: zone });
    } catch {
      return;
    }
    const tick = () => {
      this.textContent = format.format(new Date());
      this.#timer = window.setTimeout(tick, 60000 - (Date.now() % 60000) + 50);
    };
    tick();
  }

  disconnectedCallback() {
    window.clearTimeout(this.#timer);
  }
}

if (!customElements.get('s-local-time')) customElements.define('s-local-time', SLocalTime);
